import useUnsavedChangesPrompt from '../hooks/useUnsavedChangesPrompt';

interface IUnsavedChangesPromptProps {
  hasUnsavedChanges: boolean;
}

const UnsavedChangesPrompt = ({
  hasUnsavedChanges,
}: IUnsavedChangesPromptProps) => {
  useUnsavedChangesPrompt(hasUnsavedChanges);

  return null;
};

export default UnsavedChangesPrompt;
